import { Col, Row, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import Uploader from 'components/Uploader/Uploader'
import Camera from 'components/icons/Camera'
import * as faceapi from 'face-api.js'
import { PopupModel } from 'modules/DriveDetails/Style/SelectionStyle'
import {
  ButtonWrap,
  CenterText,
  ImageUploadWrapper,
  NoteText,
} from 'modules/Onboarding/Register/PersonalInfo/style'
import { deleteFile, uploadFile } from 'modules/Onboarding/actions'
import { FooterFlex } from 'modules/Roles/Style/style'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { usePrevious } from '../../../../utils/helpers'
import { LargeImageTag, RedAsterisk } from '../PersonalInfo/style'
import { SubHeading } from '../style'
import './VideoPlayer.css'
const ProfileUpload = ({
  studentFormData,
  studentData,

  setCurrent,
  activeKey,
  updateUserProfile,
  setInitialLoading,
  initalLoading = true,
}) => {
  const dispatch = new useDispatch()
  const [loading, setLoading] = useState(initalLoading)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [profile, setProfile] = useState(studentData?.profileUrl || '')
  const prevProfileUrl = usePrevious(studentData?.profileUrl || '') // Use the usePrevious hook
  const [error, setError] = useState(false)
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const webcamStream = useRef(null)
  const [pictureTaken, setPictureTaken] = useState(false)
  const [capturePic, setCapturePic] = useState(false)
  const [loadModels, setLoadModels] = useState(false)

  useEffect(() => {
    setProfile(studentData?.profileUrl)
    setInitialLoading(false)
    setLoading(false)
  }, [studentData])

  const uploadProfile = async (
    profileUrl,
    isSubmit = false,
    isDelete = false
  ) => {
    setLoading(true)
    if (!isSubmit && !isDelete) setProfile(profileUrl)
    let payload = {
      url: profileUrl,
    }
    if (isSubmit) {
      setTimeout(() => {
        setCurrent(activeKey + 1)
      }, 2000)
    }
    if (isSubmit) setInitialLoading(true)
    if (prevProfileUrl !== profile || !profileUrl) {
      let response = await updateUserProfile(studentData?.id, payload)
      if (response === true) {
        if (isDelete) {
          onRemoveImage()
          setProfile(null)
        }

        if (!isSubmit) setLoading(false)
      } else {
        ErrorMessage(
          response?.response?.data?.message ?? 'Something went wrong'
        )
        if (!isSubmit) setLoading(false)
      }
    } else  if (!isSubmit) {
        setLoading(false)
      }
    
  }
  const getFileUrl = async info => {
    let getType = info?.type?.includes('png') ? 'png' : 'jpg'
    let name =
      studentFormData?.admin?.firstName?.toLowerCase().replace(/\s/g, '') +
      '_profile' +
      '.' +
      getType
    let response = await dispatch(uploadFile(info, name))
    if (response) {
      uploadProfile(response)
    }
  }
  const onRemoveImage = async () => {
    let response = await dispatch(deleteFile(profile, false, true))
    if (response) {
      SuccessMessage('Profile removed successfully!')
    } else {
      ErrorMessage('Failed to delete the file!')
    }
  }

  useEffect(() => {
    if (capturePic) {
      const loadModels = async () => {
        const basePath =
          'https://d39w34th2iwz5l.cloudfront.net/models/stu_profile_pic/'
        try {
          setLoadModels(true)
          await Promise.all([
            faceapi.nets.ssdMobilenetv1.loadFromUri(basePath),
            faceapi.nets.faceLandmark68Net.loadFromUri(basePath),
            faceapi.nets.faceRecognitionNet.loadFromUri(basePath),
            faceapi.nets.faceExpressionNet.loadFromUri(basePath),
            faceapi.nets.ageGenderNet.loadFromUri(basePath),
            faceapi.nets.tinyFaceDetector.loadFromUri(basePath),
          ])
          setLoadModels(false)
        } catch (error) {
          // Handle errors if any of the models fail to load
          console.error('Error loading face-api.js models:', error)
        }
      }

      const setupWebcam = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: {},
          })
          if (videoRef.current) {
            videoRef.current.srcObject = stream
          }
          // Save the stream reference in the webcamStream ref
          webcamStream.current = stream
        } catch (error) {
          ErrorMessage('Oops! Error accession the webcam...')
          // alert('Error accessing webcam:', error)
        }
      }

      loadModels()
      setupWebcam()
    }
  }, [capturePic])
  const stopWebcam = () => {
    // Check if there is an active webcam stream
    if (webcamStream.current) {
      // Stop the webcam stream
      const tracks = webcamStream.current.getTracks()
      tracks.forEach(track => track.stop())

      // Remove the reference to the stream
      webcamStream.current = null

      // Set the video source object to null to stop the video element
      if (videoRef.current) {
        videoRef.current.srcObject = null
      }
    }
  }
  const isEyeOpen = eyeLandmarks => {
    const eyeAspectRatio = calculateEyeAspectRatio(eyeLandmarks)
    const threshold = 0.27
    console.log('Eye Aspect Ratio:', eyeAspectRatio)
    console.log('Threshold:', threshold)
    return eyeAspectRatio > threshold
  }

  const calculateEyeAspectRatio = eyeLandmarks => {
    const horizontalDist1 = euclideanDistance(eyeLandmarks[1], eyeLandmarks[5])
    const horizontalDist2 = euclideanDistance(eyeLandmarks[2], eyeLandmarks[4])
    const verticalDist = euclideanDistance(eyeLandmarks[0], eyeLandmarks[3])

    const eyeAspectRatio =
      (horizontalDist1 + horizontalDist2) / (2.0 * verticalDist)
    return eyeAspectRatio
  }

  const euclideanDistance = (point1, point2) => {
    const dx = point1?.x - point2?.x
    const dy = point1?.y - point2?.y
    return Math.sqrt(dx * dx + dy * dy)
  }
  const saveImage = () => {
    const canvas = canvasRef.current
    canvas.toBlob(blob => {
      if (blob) {
        // Create a File object from the Blob
        const file = new File([blob], 'captured-image.png', {
          type: 'image/png',
          lastModified: new Date().getTime(),
        })

        // Access file information

        // Do something with the file, for example, display it or send it to the server
        getFileUrl(file)
        // Update state to indicate that a picture has been taken
        // setPictureTaken(true)
        setCapturePic(false)
        stopWebcam()
        setPictureTaken(false)
      }
    }, 'image/png')
  }
  const captureImage = async () => {
    // setPictureTaken(!pictureTaken)
    if (pictureTaken) {
      setPictureTaken(false)
    } else {
      const video = videoRef.current
      const canvas = canvasRef.current
      // video.style.transform = 'scaleX(-1)'
      if (!video || !canvas) {
        ErrorMessage('Oops! Camera not found in your system')
        setPictureTaken(false)
        console.log('Video or canvas element not found')
        return
      }

      const context = canvas.getContext('2d')

      // Ensure the canvas dimensions match the video dimensions
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight

      context.clearRect(0, 0, canvas.width, canvas.height)
      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      // Flip the image horizontally
      context.scale(-1, 1)
      context.drawImage(video, -canvas.width, 0, canvas.width, canvas.height)
      // Reset the transformation
      context.setTransform(1, 0, 0, 1, 0, 0)
      try {
        const detections = await faceapi
          .detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions())
          .withFaceLandmarks()
        if (detections.length == 1) {
          const leftEyeLandmarks = detections[0].landmarks.getLeftEye()
          const rightEyeLandmarks = detections[0].landmarks.getRightEye()
          const leftEyeOpen = isEyeOpen(leftEyeLandmarks)
          const rightEyeOpen = isEyeOpen(rightEyeLandmarks)

          if (!leftEyeOpen && !rightEyeOpen) {
            // alert('Eyes are closed')
            ErrorMessage('Eyes are obstructed')
            setPictureTaken(false)
            setError(true)
          } else {
            setError(false)
            SuccessMessage('Candidate profile picture captured')
            // alert('Candidate Profile Picture Updated')
            setPictureTaken(true)
          }

          console.log('Left eye open:', leftEyeOpen)
          console.log('Right eye open:', rightEyeOpen)
        } else if (detections.length > 1) {
          // alert(
          //   'More than one face detected. Please make sure only one face is in the frame.'
          // )
          ErrorMessage(
            'More than one face detected. Please make sure only one face is in the frame.'
          )
          setPictureTaken(false)
          setError(true)
        } else {
          setError(true)
          ErrorMessage('No Face Detected')
          setPictureTaken(false)
          // alert('No face detected')
        }
      } catch (error) {
        setPictureTaken(false)
        ErrorMessage('Error during face detection')
        console.log('Error during face detection:', error)
      }
    }
  }

  const captureProfile = () => {
    setCapturePic(true)
    setPictureTaken(false)
  }

  const onClosePopup = () => {
    setCapturePic(false)
    stopWebcam()
  }
  const footer = () => {
    return (
      <div>
        <FooterFlex right>
          <Button.Secondary
            text={'Cancel'}
            onClick={() => {
              onClosePopup()
            }}
          />
          <Button.Secondary
            text={
              loadModels
                ? 'Loading...'
                : pictureTaken
                ? 'Retake Photo'
                : 'Take Photo'
            }
            onClick={() => {
              captureImage()
            }}
            disabled={loadModels}
            loading={loadModels}
          />
          <Button.Primary
            // htmlType="Save"
            // form={'negotiateForm'}
            disabled={!pictureTaken}
            text={'Save'}
            onClick={() => {
              saveImage()
            }}
          />
        </FooterFlex>
      </div>
    )
  }
  return (
    <Flex column center>
      <SubHeading flexStart>
        Upload your Profile here <RedAsterisk color="red">*</RedAsterisk>
      </SubHeading>

      {loading ? (
        <Spin />
      ) : (
        !capturePic && (
          <Control column alignCenter center>
            <Control alignCenter center>
              <ImageUploadWrapper
                column
                alignCenter
                center
                boarder={!profile}
                ml=""
                size="150px"
              >
                {!profile && (
                  <Fragment>
                    <Control column alignCenter>
                      <Camera />
                    </Control>
                    <Control column alignCenter top={'3px'} gap={'2px'}>
                      <Control column alignCenter>
                        Max file size: 2MB
                      </Control>
                      <Control column alignCenter>
                        Dimension: 130*130
                      </Control>
                      <Control column alignCenter>
                        File format: .png, .jpeg
                      </Control>
                    </Control>
                  </Fragment>
                )}
                {profile && <LargeImageTag src={profile} />}
              </ImageUploadWrapper>
              {profile ? (
                <ButtonWrap>
                  <Control column width="100%" flexEnd gap="10px" alignCenter>
                    <Uploader
                      isDelete={true}
                      file={profile}
                      setFile={uploadProfile}
                      showButtonUploder={!!profile}
                      fileName={
                        studentFormData?.admin?.firstName
                          ?.toLowerCase()
                          .replace(/\s/g, '') + '_profile'
                      }
                      captureProfile={captureProfile}
                      setIsModalOpen={setIsModalOpen}
                      isModalOpen={isModalOpen}
                      setError={setError}
                      error={error}
                      profileUploadPage={true}
                    />
                    <Button.Secondary
                      text="Remove"
                      onClick={() => {
                        uploadProfile(null, false, true)
                      }}
                      height={'32px'}
                    />
                  </Control>
                </ButtonWrap>
              ) : null}
            </Control>

            {!profile && (
              
                <Control alignCenter center>
                  <Uploader
                    file={profile}
                    setFile={uploadProfile}
                    showTextUploder={!profile}
                    fileName={
                      studentFormData?.admin?.firstName
                        ?.toLowerCase()
                        .replace(/\s/g, '') + '_profile'
                    }
                    captureProfile={captureProfile}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    setError={setError}
                    error={error}
                    profileUploadPage={true}
                  />
                </Control>
            
            )}
            {!profile && (
              <Control alignCenter center top={'2px'}>
                <CenterText>
                  <NoteText>Note:</NoteText>
                  <NoteText>
                    Max file size: 2MB | Dimension: 130*130 | File format: .png,
                    .jpeg{' '}
                  </NoteText>
                </CenterText>
              </Control>
            )}
            <Control top="30px" flexEnd gap={'10px'}>
              <Button.Secondary
                text="Back"
                onClick={() => setCurrent(activeKey - 1)}
              />
              {profile && (
                <Button.Primary
                  text="Save and Continue"
                  onClick={() => {
                    uploadProfile(profile, true)
                  }}
                />
              )}
            </Control>
          </Control>
        )
      )}

      <PopupModel
        open={capturePic}
        footer={footer()}
        closable={false}
        onCancel={onClosePopup}
        // width={'35%'}
        maskClosable={false}
        bodyStyle={{
          padding: '0px',
          backgroundColor: '#f4f4ffd4',
          display: 'grid',
          borderRadius: '5px',
        }}
        footerStyle={{ background: '#f4f4ffd4' }}
      >
        <video
          ref={videoRef}
          autoPlay
          playsInline
          height={'100%'}
          width={'96%'}
          style={{
            display: pictureTaken ? 'none' : 'flex',
            margin: '0.5em',
            transform: 'scaleX(-1)',
          }}
        > <track kind="captions" src="captions.vtt" label="English" default /></video>
        <canvas
          ref={canvasRef}
          id="overlay"
          height={'100%'}
          width={'96%'}
          style={{
            height: '100%',
            width: '96%',
            margin: '0.5em',
            display: pictureTaken ? 'flex' : 'none',
          }}
        />
        <Control
          alignCenter
          center
          top={'10px'}
          style={{
            display: 'block',
            border: ' 1px dashed #edd4f9',
            padding: '0.5em',
            margin: '1em',
            width: '93%',
          }}
        >
          <CenterText>
            <NoteText>Note:</NoteText>
            <NoteText>
              <Row>
                <Col span={24}>1. You should be inside the frame</Col>
              </Row>
              <Row>
                <Col span={24}>2. Your eyes should be open.</Col>
              </Row>
              <Row>
                <Col span={24}>3. You should be in the lighter area.</Col>
              </Row>
            </NoteText>
          </CenterText>
        </Control>
      </PopupModel>
    </Flex>
  )
}

export default ProfileUpload
